import { StateSchema } from 'app/config/storeConfig/types';
import { LateChargeSettingFormDrawerSchema } from '../types';

export const getLateChargeSettingFormState = (state: StateSchema): LateChargeSettingFormDrawerSchema => state.lateChargeSettingFormDrawer;
